import { render, staticRenderFns } from "./InfoTypeDetailView.vue?vue&type=template&id=85b76080&scoped=true"
import script from "./InfoTypeDetailView.vue?vue&type=script&lang=js"
export * from "./InfoTypeDetailView.vue?vue&type=script&lang=js"
import style0 from "./InfoTypeDetailView.vue?vue&type=style&index=0&id=85b76080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b76080",
  null
  
)

export default component.exports